import axios from "axios";

// Backend error responses carry a service-prefixed code such as "USR-232" somewhere in the body.
export const getApiErrorCode = (error: unknown) => {
  const body = axios.isAxiosError(error) ? error.response?.data : undefined;
  return (typeof body === "string" ? body : JSON.stringify(body ?? "")).match(/[A-Z]{3}-\d{3}/)?.[0];
};

export const getApiErrorStatus = (error: unknown) => (axios.isAxiosError(error) ? error.response?.status : undefined);
